/* eslint-disable react-hooks/rules-of-hooks */
"use client";
import React from "react";
import { motion } from "framer-motion";
import Pill from "../common/Pill";
import NoCode from "../../assets/NoCode.svg";
import QRCode from "../../assets/qrCodeDeployment.svg";
import Portal from "../../assets/Portal.svg";
import Scalable from "../../assets/Scalable.svg";

const features = [
  {
    id: "01",
    title: "No-Code Agent Builder",
    description:
      "Build your own AI voice assistant for your physical business. No developers needed. With AgoraVoice, anyone on your team can create and manage AI agents, just give your agent a personality with simple instructions (e.g. “You are a friendly receptionist”) and upload your documents to create its knowledge base. It's as easy as attaching a file to an email.",
    image: NoCode,
  },
  {
    id: "02",
    title: "Instant QR Code Deployment",
    description:
      "Our platform automatically generates a unique QR code for your agent. Download, print, and place it anywhere: on a table, a product display, a museum wall, or an event badge. You've just connected your physical space to a digital voice. No apps, no barriers. Just direct, friction-less interaction on your smartphone.",
    image: QRCode,
  },
  {
    id: "03",
    title: "Owner’s Portal & Analytics",
    description:
      "Know exactly what your customers want. Every question a customer asks is a valuable piece of data. Our dashboard tracks real conversations, and transforms them into clear, actionable insights that help you improve your business.",
    image: Portal,
  },
  {
    id: "04",
    title: "Scalable & Integrated",
    description:
      "Starting with a single agent or planning to deploy multiple agents for various uses, our platform provides the power and flexibility you need. AgoraVoice can also connect to your POS, payment, or support systems, making your AI assistant a true part of your business workflow. Whether you run a café, fitness studio, or retail shop, scale effortlessly and deliver a consistent, modern customer experience. Reach out to discuss integrations.",
    image: Scalable,
  },
];

const WhyAgoraVoice = () => {
  return (
      <section className="bg-[#FFF7EB] px-4">
        <div className="max-w-4xl mx-auto relative z-10 px-4">

          <div className="text-center mb-12 lg:mb-16 flex justify-center flex-col items-center">
            <Pill text="WHY AGORAVOICE" backgroundColor="#F3E6E6" />
            <h2 className="text-3xl md:text-4xl lg:text-[44px] font-semibold mb-4 lg:mb-6 mt-6">
              Turn Any Space Into a Conversation
            </h2>
            <p className="text-gray-600 mt-4 text-[15px] px-10">
              AgoraVoice gives you the tools to deploy a customer AI voice
              assistant, embed intelligent conversations anywhere, boost
              customer experiences and scale without limits.{" "}
            </p>
          </div>

        <div className="grid gap-6 mb-4">
  {features.map((feature, index) => {
    const isReversed = index === 1 || index === 3; 

    return (
      <motion.div
        key={feature.index}
        style={{
        top: `max(6rem, min(10rem, -100% - 2rem + 100vh))`,
          marginBottom: index === feature.length - 1 ? "0px" : "0.2rem",
        }}
        className={`bg-white story-card sticky border p-3 border-[#F3E6E6] rounded-2xl shadow-xl overflow-hidden flex flex-col sm:flex-row gap-6 sm:gap-8 ${
          isReversed ? "sm:flex-row-reverse" : ""
        }`}
      >
        <div className="flex-1 flex flex-col justify-between p-3 relative">
          <div>
            <h3 className="text-[25px] font-bold bg-gradient-to-r from-[#272020] to-[#690101] bg-clip-text text-transparent mb-3 sm:mb-4 leading-tight">
              {feature.title}
            </h3>
            <p className="text-[#5C5A5A] text-sm leading-relaxed">
              {feature.description}
            </p>
          </div>

          <div className="hidden sm:block mt-10 absolute bottom-4 left-4">
            <h4 className="text-4xl md:text-5xl bg-gradient-to-r from-[#272020] to-[#690101] bg-clip-text text-transparent">
              {feature.id}
            </h4>
          </div>
        </div>
        <div className="flex-1 flex justify-center items-center mt-6 sm:mt-0">
          <img
            src={feature.image}
            alt={feature.title}
            className="w-full max-w-[350px] sm:max-w-[400px] md:max-w-none h-auto rounded-lg object-contain"
          />
        </div>
      </motion.div>
    );
  })}
</div>

        </div>
      </section>
  );
};

export default WhyAgoraVoice;
